import React from 'react'

const Footer = () => {
  return (
      <div className="main-footer">
        <div className="row">
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="footer_logotxt">Copyright © 2026</div>
          </div>
        </div>
      </div>
  )
}

export default Footer